/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UniqueIdQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("UniqueIdQueryOperator");
    }

    getFixupPrototypeFunction() { return UniqueIdQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<UniqueIdQueryOperator>): UniqueIdQueryOperator {
        let obj = Object.assign(new UniqueIdQueryOperator(), model);
        UniqueIdQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UniqueIdQueryOperator>): UniqueIdQueryOperator {
        if (!model) return null;
        return UniqueIdQueryOperator.newInstance(<UniqueIdQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UniqueIdQueryOperator) {
        if (!obj) return;

        models.UniqueIdQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UniqueIdQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, UniqueIdQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * List of unique ID(s) to include.
     */
    ids: Array<string>;

}
